export default "__VITE_ASSET__DM6DPSTd__"